import React, { forwardRef } from "react";
import cn from "classnames";
import classNames from "classnames";
import styles from "./Calendar.module.scss";
import dayjs from "dayjs";
import MonthSelector from "../MonthSelector";
import Loader from "../Loader";
import Header from "./components/Header";
import Week from "./components/Week";
import Day from "./components/Day";
import ExpandableRow from "../ExpandableRow";
import { FocusTrap, FocusTrapFeatures } from "@headlessui/react";
import Button from "../Button/Button";
const Calendar = forwardRef(({ className, bodyClassName, monthSelectorClassName, headerClassName, weekClassName, monthSelectorKind, selectedMonth, onNextMonth, onPrevMonth, onNextYear, onPrevYear, minDate = "1940-01-01", maxDate = "2100-12-31", disabled, disabledDates = [], enabledDates, selectedDates = [], bookedDates = [], focusedDate, renderExpand, unfocusDate, onDayClick, showWeekPicker, renderDay = Day, loading, dataCySuffix, }, ref) => {
    const sundays = firstWeekDaysOfMonth(selectedMonth);
    const getDayParams = (day) => ({
        isToday: dayjs().isSame(dayjs(day), "day"),
        isDisabled: enabledDates != null
            ? !enabledDates.includes(day)
            : disabledDates.includes(day) || minDate > day || maxDate < day,
        isSelected: selectedDates.includes(day),
        isFocused: day === focusedDate,
        isBooked: bookedDates.includes(day),
    });
    const expand = focusedDate && renderExpand ? renderExpand(focusedDate) : null;
    const focusedDateSunday = dayjs(focusedDate).startOf("week");
    const dataCy = (name) => {
        return dataCySuffix ? `${name}-${dataCySuffix}` : name;
    };
    const dataCyProps = {
        root: dataCy("ukt-calendar"),
        calendarTable: dataCy("ukt-calendar-table"),
        calendarBody: dataCy("ukt-calendar-body"),
    };
    return (React.createElement("div", { ref: ref, "data-cy": dataCyProps.root, className: cn("ukt-calendar", "flex min-h-[268px] min-w-[200px] flex-col", disabled && styles.disabled, className) },
        React.createElement(MonthSelector, { className: monthSelectorClassName, kind: monthSelectorKind, selectedMonth: selectedMonth, onNextMonth: onNextMonth, onPrevMonth: onPrevMonth, onNextYear: onNextYear, onPrevYear: onPrevYear, minMonth: minDate, maxMonth: maxDate }),
        React.createElement("div", { className: cn("relative", bodyClassName) },
            React.createElement(Header, { showWeekPicker: showWeekPicker, className: headerClassName }),
            React.createElement("div", { "data-cy": dataCyProps.calendarBody }, sundays.map((sunday) => (React.createElement(React.Fragment, { key: sunday.format("YYYY-MM-DD") },
                React.createElement(ExpandableRow, { className: cn("w-full"), isOpen: Boolean(expand && sunday.isSame(focusedDateSunday)), children: React.createElement(Week, { className: weekClassName, renderDay: (day) => renderDay({
                            date: day,
                            onClick: disabled ? undefined : onDayClick,
                            ...getDayParams(day),
                        }), weekStart: sunday, showWeekPicker: showWeekPicker }), expand: React.createElement("div", { key: focusedDate, className: classNames(Boolean(expand && sunday.isSame(focusedDateSunday)) &&
                            styles.scaleUp) }, expand && sunday.isSame(focusedDateSunday) && (React.createElement(FocusTrap, { features: FocusTrapFeatures.InitialFocus |
                            FocusTrapFeatures.TabLock |
                            FocusTrapFeatures.RestoreFocus, "aria-label": `${dayjs(focusedDate).format("D MMMM YYYY")} Details View`, role: "dialog", className: "focus-trap relative flex items-center justify-center pt-1" },
                        React.createElement(Button, { kind: "text", onClick: () => unfocusDate?.(), className: "sr-only !absolute !top-0 !left-0 z-10  !p-1 focus-visible:not-sr-only" }, "Back To Calendar"),
                        React.createElement("div", null, expand)))) }))))),
            loading && React.createElement(Loader, { className: styles.loader }))));
});
const firstWeekDaysOfMonth = (month) => {
    const selectedMonthDayJs = dayjs(month);
    const firstWeekSunday = selectedMonthDayJs.startOf("month").startOf("week");
    let sundays = [];
    let sunday = firstWeekSunday;
    do {
        sundays.push(sunday);
        sunday = sunday.add(1, "week");
    } while (sunday.month() === selectedMonthDayJs.month());
    return sundays;
};
export default Calendar;
//# sourceMappingURL=Calendar.js.map